import { queryOptions, type MutationOptions, type QueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

async function fetchSongs(playlistId?: string) {
	const response = await api.api.songs.get({ query: { playlistId } })
	if (response.error) {
		throw new Error('Failed to fetch songs')
	}
	return response.data
}

export function songsQueryOptions(playlistId?: string) {
	return queryOptions({
		queryKey: ['songs', { playlistId }],
		queryFn: () => fetchSongs(playlistId),
	})
}

async function reorderSongs(playlistId: string, orderedIds: string[]) {
	const response = await api.api.songs.reorder.patch({ playlistId, orderedIds })
	if (response.error) {
		throw new Error('Failed to reorder songs')
	}
	return response.data
}

export function reorderSongsMutationOptions(
	queryClient: QueryClient,
	playlistId: string,
): MutationOptions<unknown, Error, string[]> {
	return {
		mutationFn: (orderedIds: string[]) => reorderSongs(playlistId, orderedIds),
		onError: () => {
			queryClient.invalidateQueries(songsQueryOptions(playlistId))
		},
	}
}

async function shuffleSongs(playlistId: string) {
	const response = await api.api.songs.shuffle.post({ playlistId })
	if (response.error) {
		throw new Error('Failed to shuffle songs')
	}
	return response.data
}

export function shuffleSongsMutationOptions(
	queryClient: QueryClient,
	playlistId: string,
): MutationOptions<unknown, Error, void> {
	return {
		mutationFn: () => shuffleSongs(playlistId),
		onSuccess: () => {
			queryClient.invalidateQueries(songsQueryOptions(playlistId))
			queryClient.invalidateQueries({ queryKey: ['playlists', playlistId] })
		},
	}
}
